export default function Canvas_Lines() {
  return (
    <div>
      <h1>Canvas_Lines Component</h1>
    </div>
  );
}
